const checkDateInFuture = (date: Date): boolean => {
  const now = new Date();
  return date > now;
};

export default checkDateInFuture;
